import { render } from "./swiperMain.vue?vue&type=template&id=467f7f53&scoped=true"
import script from "./swiperMain.vue?vue&type=script&lang=js"
export * from "./swiperMain.vue?vue&type=script&lang=js"

import "./swiperMain.vue?vue&type=style&index=0&id=467f7f53&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467f7f53"]])

export default __exports__